module.exports = __webpack_public_path__ + "static/media/Group 37393.4d29e4c1.png";